import React from 'react';
import '../../App.scss';

import { getPoweredByLogo, getBrandName, getBrandUrl } from '../../utils/BrandConfig';
import { useBrandProduct } from '../../contexts/BrandContext';

export default function PoweredByStrike(props) {
  const { brand } = useBrandProduct();
  const style_elCashlessTippingText = {
    fontSize: 8.5,
    color: 'rgba(0, 0, 0, 0.8500)',
    textAlign: 'center',
  };
  
  const style_elStrikeLogoImage = {
    width: '75%',
    maxWidth: '200px',
    height: 'auto',
    cursor: 'pointer',
    pointerEvents: 'auto',
  };

  return (
    <div className="flowRow flowRow_FooterCard_elCashlessTippingText_46302">
        <div className="poweredBy elCashlessTippingText">
            <div className="font-tahomaBold" style={style_elCashlessTippingText}>
              <a href={getBrandUrl(brand)} target="_blank" rel="noopener noreferrer" style={{ color: '#000' }}>
                <div>
                    <img className="elStrikeFullLogoImage" style={style_elStrikeLogoImage} src={getPoweredByLogo(brand)} alt={getBrandName(brand)} />
                </div>
              </a>
            </div>
        </div>
    </div>
  );
}